import { useCallback } from "react";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";

import * as Styled from "./styles";
import { TableTextFilterProps } from "./types";

const TableTextFilter: React.FC<TableTextFilterProps> = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
}) => {
  const handleKeyDown = useCallback<React.KeyboardEventHandler<HTMLDivElement>>(
    (event) => event.stopPropagation(),
    []
  );

  const handleChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
    ({ target }) => {
      setSelectedKeys(target.value ? [target.value] : []);
    },
    [setSelectedKeys]
  );

  const handleSearch = useCallback(() => {
    confirm();
  }, [confirm]);

  const handleReset = useCallback(() => {
    setSelectedKeys([]);
    confirm();
  }, [confirm, setSelectedKeys]);

  return (
    <Styled.TableTextFilterWrapper onKeyDown={handleKeyDown}>
      <Styled.TableTextFilterInputWrapper>
        <Styled.TableTextFilterInput
          value={selectedKeys[0]}
          onChange={handleChange}
          onPressEnter={handleSearch}
        />
      </Styled.TableTextFilterInputWrapper>
      <Styled.TableTextFilterActions>
        <Button type="link" size="small" onClick={handleReset}>
          <FormattedMessage defaultMessage="Reset" />
        </Button>
        <Button type="primary" size="small" onClick={handleSearch}>
          <FormattedMessage defaultMessage="OK" />
        </Button>
      </Styled.TableTextFilterActions>
    </Styled.TableTextFilterWrapper>
  );
};

export default TableTextFilter;
